var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-profile-02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    filter: "url(#filter0_i_159_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7998 41.0248C4.7998 33.4737 11.1084 27.3524 23.9998 27.3524C36.8912 27.3524 43.1998 33.4737 43.1998 41.0248C43.1998 42.2261 42.3233 43.2 41.2422 43.2H6.75745C5.67627 43.2 4.7998 42.2261 4.7998 41.0248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1998 12C31.1998 15.9764 27.9763 19.2 23.9998 19.2C20.0234 19.2 16.7998 15.9764 16.7998 12C16.7998 8.02354 20.0234 4.79999 23.9998 4.79999C27.9763 4.79999 31.1998 8.02354 31.1998 12Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_159_58",
    x: 4.7998,
    y: 4.79999,
    width: 38.3999,
    height: 42.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_159_58"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileIcon);
export default __webpack_public_path__ + "static/media/user-profile-icon.bef71fd21f8b6c1acda609abcb74d2bd.svg";
export { ForwardRef as ReactComponent };